import React from 'react';
import { Alert, Button, Divider, Paper, Stack, Typography } from '@mui/material';
import recurrenceSummary from '../utils/recurrenceSummary';

export default function EmailCampaignReviewStep({
  campaign,
  estimatedRecipients,
  onConfirm,
  confirmLoading = false,
  readOnly = false,
}) {
  const scheduleText = recurrenceSummary(campaign || {});

  return (
    <Stack spacing={2}>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Stack spacing={1}>
          <Typography variant="subtitle2">Title</Typography>
          <Typography>{campaign?.title || '-'}</Typography>

          <Divider />

          <Typography variant="subtitle2">Audience</Typography>
          <Typography>{campaign?.audience_mode || '-'}</Typography>
          <Typography variant="body2" color="text.secondary">
            Estimated recipients: {Number(estimatedRecipients || 0)}
          </Typography>

          <Divider />

          <Typography variant="subtitle2">Content</Typography>
          <Typography>{campaign?.subject || '-'}</Typography>
          <Typography variant="body2" color="text.secondary">
            Bilingual: {campaign?.is_bilingual ? 'Yes' : 'No'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Channels: Email{campaign?.send_in_app_notification ? ' + In-app notification' : ''}
          </Typography>

          <Divider />

          <Typography variant="subtitle2">Schedule</Typography>
          <Typography variant="body2">{scheduleText}</Typography>
        </Stack>
      </Paper>

      {Number(estimatedRecipients || 0) === 0 ? (
        <Alert severity="warning">Recipient estimate is zero. Scheduling will likely fail with no recipients.</Alert>
      ) : null}

      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={readOnly || confirmLoading}
      >
        {confirmLoading ? 'Submitting...' : 'Confirm & Schedule'}
      </Button>
    </Stack>
  );
}
